export function convertToCSV(objArray) {
  if (!Array.isArray(objArray) || objArray.length === 0) return "";

  const headers = Object.keys(objArray[0]);
  const escape = (val) => {
    let str = val == null ? "" : String(val);
    if (str.includes('"')) str = str.replace(/"/g, '""');
    return `"${str}"`;
  };

  // header row
  let csv = headers.map(escape).join(",") + "\r\n";

  // data rows
  objArray.forEach((row) => {
    const line = headers.map((key) => escape(row[key])).join(",");
    csv += line + "\r\n";
  });

  return csv;
}

/**
 * Exports a CSV file of cumulative data vs transactions by label (e.g., month).
 *
 * @param {Object} params
 * @param {{ labels: string[], datasets: Array<{ data: Array<number> }> }} params.chartData
 * @param {string} params.selectedYear
 * @param {string|Object} params.range           - JSON string or object with $gte, $lte
 * @param {string} params.storess                - Store name
 * @param {string} [params.fileName]             - Filename for download
 */
export function exportCumulativeTransactionsCSV({
  chartData,
  selectedYear,
  range,
  storess,
  fileName = "CumulativeTransactions.csv",
}) {
  if (!chartData || !chartData.labels || !chartData.datasets) {
    console.error("exportCumulativeTransactionsCSV: invalid chartData");
    return;
  }

  const cumulative = chartData.datasets[0]?.data || [];
  const transactions = chartData.datasets[1]?.data || [];

  // parse date range
  const dateRange = typeof range === "string" ? JSON.parse(range) : range || {};
  const from = dateRange.$lte?.split("T")[0] || "";
  const to = dateRange.$gte?.split("T")[0] || "";
  const dateLabel = `${selectedYear}${from} ${selectedYear}${to}`;

  // build rows as objects
  const rows = chartData.labels.map((label, idx) => ({
    Brand: "Angels Pizza",
    Store: storess || "All Stores",
    Date: dateLabel,
    Label: label,
    Cumulative: cumulative[idx],
    Transaction: transactions[idx],
  }));

  // convert to CSV
  const csvString = convertToCSV(rows);
  if (!csvString) {
    console.warn("exportCumulativeTransactionsCSV: no data to export");
    return;
  }

  // trigger download
  const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
